/**
 * Questions about harassment situations the user witnessed.
 *
 * FIXED BUG (Mar 2025):
 * Previously only td_002 through td_009 were saved correctly. Options 10–12 (td_010, td_011, td_012,
 * td_013) were not saved to the table.
 *
 * CAUSE: The template value={`td_00${index + 2}`} produced incorrect values for index >= 8:
 *   - index 8 → "td_0010" (expected: "td_010")
 *   - index 9 → "td_0011" (expected: "td_011")
 *   - etc.
 * The transform (sexualHarassmentDataTransform) looks for "td_010", "td_011", etc., so
 * list.includes("td_010") failed when the form stored "td_0010".
 *
 * FIX: Use an explicit OPTIONS_VALUES array with the correct field names.
 *
 * Components with similar checkbox → DB field logic (all use explicit values):
 *   - _18.1.ACT_001-008_preguntasAccionesTestigos.tsx (explicit values ✓)
 *   - _14.1.BAD_001-010_barrerasDeDenuncia.tsx (explicit values ✓)
 *   - _4.4.SP_004-011_canalesDeDenuncias.tsx (explicit values ✓)
 *   - _12.2.PAD_003-007_preguntasPerfilAcosador.tsx (explicit values ✓)
 */
import { Checkbox } from "@mantine/core";
import CheckboxSurvey from "../../../components/form/Checkbox";
import { useTranslation } from "react-i18next";

type Props = {
  form: any;
};

const OPTIONS_VALUES = [
  "td_002",
  "td_003",
  "td_004",
  "td_005",
  "td_006",
  "td_007",
  "td_008",
  "td_009",
  "td_010",
  "td_011",
  "td_012",
  "td_013",
];

const Component = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <CheckboxSurvey
      label={t("declaredWitnessQuestions.label")}
      {...form.getInputProps("TD_002_013")}
    >
      {(
        t("declaredWitnessQuestions.options", {
          returnObjects: true,
        }) as string[]
      ).map((option, index) => (
        <Checkbox
          key={OPTIONS_VALUES[index]}
          label={option}
          value={OPTIONS_VALUES[index]}
        />
      ))}
    </CheckboxSurvey>
  );
};

export default Component;
